import { render } from "./CarouselSimple.vue?vue&type=template&id=1262c970"
import script from "./CarouselSimple.vue?vue&type=script&lang=js"
export * from "./CarouselSimple.vue?vue&type=script&lang=js"

import "./CarouselSimple.vue?vue&type=style&index=0&id=1262c970&lang=scss"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__